const sectionFadeInStyle = `
@keyframes concierge-fade-in {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}`;
const GREY_PLACEHOLDER_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Crect width='120' height='120' fill='%23f5f5f5' rx='8'/%3E%3C/svg%3E";
export {
  GREY_PLACEHOLDER_SVG,
  sectionFadeInStyle
};
//# sourceMappingURL=utils.js.map
